import React from "react";
import Link from "helpers/link";
import { PortableText } from "@portabletext/react";
import { getButtonStyle } from "helpers/get-button-style";
import VideoPlayer from "components/video-player";
import clean from "helpers/sanitize-html";

const Video = ({ value }) => {
  const { video } = value;

  if (video.includes("youtube"))
    return (
      <iframe
        width="100%"
        height="400"
        src={video.includes("youtube") ? video.replace("watch?v=", "embed/").replace("&", "?") : video}
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
      ></iframe>
    );
  return (
    <div className="w-full h-96">
      <VideoPlayer videoLink={video} />
    </div>
  );
};

//Types
const ImageRenderer = ({ value: node }) => (
  <img src={node.src} alt={node.alt} />
);

const ButtonRenderer = ({ value: node }) => (
  <Link className={getButtonStyle(node?.style)} to={node?.url}>
    {node?.text}
  </Link>
);

// Marks
const Links = ({ children, value }) => <Link to={value.href}>{children}</Link>;

const Color = ({ children, value }) => (
  <span style={{ color: value?.color?.hex }}>{children}</span>
);

const Code = (value) => {
  const sanitizedHtml = clean(value.text);
  return <code dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />
}

// const richTextComponents = {
//   types: {
//     Image: ImageRenderer,
//     Button: ButtonRenderer,
//     Video: Video,
//   },
//   marks: {
//     link: Links,
//     highlight: Color,
//     color: Color,
//   },
// };

const defaultList = {
  bullet: ({children}) => <ul className="list-disc ml-7 paragraph-normal text-gray-800 sm:text-base leading-7 mb-5">{children}</ul>,
  number: ({children}) => <ol className="list-decimal ml-7 paragraph-normal text-gray-800 sm:text-base leading-7 mb-5">{children}</ol>
}

const RichText = (props) => (
  <PortableText
    value={props.value ?? props.data?.data}
    components={{
      types: {
        // table: TableSerializer,
        Image: ImageRenderer, // to support old schema
        Button: ButtonRenderer, // to support old schema
        Video: Video, // to support old schema
        myImage: ImageRenderer,
        button: ButtonRenderer,
        video: Video,
      },
      block: {
        ...props.components
      },
      list: {
        ...defaultList,
        ...props.list
      },
      ...props.moreOptions,
      marks: {
        link: Links,
        highlight: Color,
        color: Color,
        code: Code,
      },
    }}
    />
);

export default RichText;
